<template>
  <div class="mod-cert__selCertCourse">
    <div style="margin-top: 2px">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-card class="aui-card--fill">
            <el-form
              label-width="120px"
              :inline="true"
              :model="dataForm"
              ref="dataForm"
              style="display: flex"
              @keyup.enter.native="quertCourse()"
              @submit.native.prevent
            >
              <el-row>
                <el-col :span="10">
                  <el-form-item
                    :label="$t('couse.coursecodes')"
                    class="firstOne"
                  >
                    <el-input
                      v-model="dataForm.courseCode"
                      clearable
                      class="codeLeft"
                      :placeholder="$t('couse.coursectotle')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :label="$t('couse.coursekinds')">
                    <el-select
                      v-model="courseKind"
                      multiple
                      collapse-tags
                      clearable
                      :placeholder="$t('course.select')"
                    >
                      <el-option
                        v-for="(item, index) in newcourseKind"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item>
                    <el-button
                      class="M-search"
                      type="primary"
                      @click="quertCourse()"
                      >{{ $t("query") }}</el-button
                    >
                    <div style="height: 5px"></div>
                    <el-button
                      class="el-back M-search M-margin-l"
                      type="info"
                      @click="resetQuery"
                      >{{ $t("reset") }}</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-table
              v-loading="dataListLoading"
              ref="selectCourseinfo"
              height="400"
              :data="dataList"
              border
              :header-cell-style="{ background: '#f1f1f1 !important' }"
              :cell-style="cellStyle"
              style="width: 100%"
              @select="selectRedio"
              @select-all="selectAllRedio"
            >
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
                style="background: rgb(255, 255, 255)"
                :selectable="checkboxT"
              ></el-table-column>
              <el-table-column
                prop="courseCode"
                :label="$t('couse.coursecode')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="courseNameCn"
                :label="$t('couse.courseNamecns')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="courseKind"
                :label="$t('couse.courseCoursekinds')"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
            <el-row> </el-row>
            <el-row>
              <span style="width: 200px">注：该列表只显示已发布的课程</span>
            </el-row>
            <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              style="text-align: right"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </el-card>
        </el-col>
        <!--已选课程-->
        <el-col :span="6">
          <el-card class="box-card">
            <div class="selectBox">
              <p class="dataBox">{{ $t("cert.selectedCourse") }}</p>
              <div class="btns">
                <el-button plain @click="onOk('1')" size="mini">{{
                  $t("cancel")
                }}</el-button>
                <el-button
                  type="primary"
                  style="margin-left: 5px"
                  @click="onOk('2')"
                  size="mini"
                  >{{ $t("confirm") }}</el-button
                >
              </div>
            </div>
            <div style="max-height: 465px; overflow: auto; overflow-x: hidden">
              <el-row :gutter="10">
                <el-col v-for="tag in courseData" :key="tag.courseCode">
                  <el-tag
                    style="margin-bottom: 10px; width: 95%; text-align: left"
                    :key="tag.courseCode"
                    @close="handleClose(tag)"
                    closable
                  >
                    <div
                      style="
                        width: 90%;
                        float: left;
                        overflow-x: hidden;
                        overflow-y: hidden;
                        word-break: keep-all;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ tag.courseNameCn }}
                    </div>
                  </el-tag>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  props: {
    inputvalues: String,
    courseInfoList: {
      type: Array,
      required: false,
    },
  },
  data() {
    let _this = this;
    return {
      inputvaluesz: "",
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: "/learning/courseBaseInfo/page",
        getDataListIsPage: true,
        deleteIsBatch: true,
      },
      // 编辑面板标签对齐方式
      labelPosition: "left",
      // 查询面板标签宽度
      queryLabelWidth: "120px",
      // 课程类型
      newcourseKind: _this.enums["newcourseKind"],
      datalist: [],
      courseKind: [],
      dataForm: {
        courseKindplan: "80",
        courseKind: "",
        courseCode: "",
        courseStatus: "20",
      },
      courseData: [],
    };
  },
  computed: {
    courseEmitData() {
      return this.$store.state.courseEmit;
    },
  },
  created() {
    this.mixinViewModuleOptions.getDataListURL =
      "/learning/courseBaseInfo/page";
    this.mixinViewModuleOptions.getDataListIsPage = true;
    this.quertCourse();
  },
  methods: {
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return {
        background: "#fff",
      };
      // }
    },
    // 获取数据列表
    getDataList() {
      if (this.courseKind != null || this.courseKind !== "") {
        this.dataForm.courseKind = this.courseKind + "";
      }
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm));
      if ("regionIds" in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = "";
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(",");
        }
      }
      this.dataListLoading = true;
      //this.$message(this.courseEmitData.courseCode)
      this.$request
        .get(this.mixinViewModuleOptions.getDataListURL, {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage
            ? this.page
            : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage
            ? this.limit
            : null,
          courseStatus: "20",
          ...newDataForm,
        })
        .then((res, total, code, data) => {
          console.log(res);
          // this.$message('zzzzz******************' + data.data.records)
          this.dataListLoading = false;
          let resultList = data.data.records;
          this.dataList = resultList;
          this.total = this.mixinViewModuleOptions.getDataListIsPage
            ? parseInt(data.data.total, 10)
            : 0;
          // 延迟加载
          this.$nextTick(() => {
            this.querSelect();
          });
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    initMethods() {
      this.dataForm = {
        courseCode: "",
        courseKind: "",
      };
      this.courseData = [];
      this.quertCourse();
    },
    toggleSelection(rows) {
      var chexcksss = this.$refs.selectCourseinfo.selection; // 得到选中的值
      chexcksss.forEach((row) => {
        this.datalist.push({
          id: row.courseId,
          courseKind: row.courseCatalog,
          course: row.courseNameCn + "(" + row.courseCode + ")",
        });
      });
      this.$emit("inputss", this.datalist);
      this.datalist = [];
    },
    quertCourse() {
      this.page = 1;
      this.getDataList();
    },
    // 重置查询条件
    resetQuery() {
      this.courseKind = "";
      this.dataForm = {
        courseCode: "",
        courseKind: "",
      };
      this.page = 1;
      this.getDataList();
    },
    selectRedio: function selectRedio(selection, row) {
      let result = [];
      for (let a = 0; a < selection.length; a++) {
        if (row.courseId === selection[a].courseId) {
          result.push(row);
          break;
        }
      }
      if (result.length > 0) {
        if (
          this.isSelectElection &&
          this.$refs.selectCourseinfo.selection.length > 1
        ) {
          this.$refs.selectCourseinfo.clearSelection(); // 清空
          this.courseData = [];
          this.courseData.push(row);
          this.$refs.selectCourseinfo.toggleRowSelection(row); // 选择当前行
        } else {
          if (row) {
            if (this.courseData && this.courseInfoList) {
              for (var i = 0; i < this.courseInfoList.length; i++) {
                // this.$message(this.courseInfoList[i].conditionCourseId + '' + row.courseId)
                if (
                  String(this.courseInfoList[i].conditionCourseId) ===
                  String(row.courseId)
                ) {
                  // this.$message.warning(this.$t('cert.courseondb'))
                  this.$refs.selectCourseinfo.toggleRowSelection(row, false); // 清空
                  return false;
                }
              }
            }
            this.courseData.push(row);
          }
        }
      } else {
        if (
          this.isSelectElection &&
          this.$refs.selectCourseinfo.selection.length > 1
        ) {
          this.$refs.selectCourseinfo.clearSelection(); // 清空
          this.courseData = [];
        } else {
          for (let b = 0; b < this.courseData.length; b++) {
            if (row.courseId === this.courseData[b].courseId) {
              this.courseData.splice(b, 1);
              break;
            }
          }
        }
      }
    },
    // 控制可选项
    checkboxT(row, index) {
      let _this = this;
      let checkFlg = true;
      if (_this.courseInfoList && _this.courseInfoList.length > 0) {
        _this.courseInfoList.forEach(function (item) {
          //  this.$message(item[0] + '***************' + row.courseId)
          if (row.courseId === item.conditionCourseId) {
            checkFlg = false;
          }
        });
      }
      return checkFlg;
    },
    // 全选
    selectAllRedio(selection) {
      let _this = this;
      if (selection) {
        let courseDataB = [];
        if (_this.courseData && _this.courseData.length > 0) {
          _this.courseData.forEach(function (item) {
            courseDataB.push(item);
          });
        }
        if (selection.length > 0) {
          for (var i = 0; i < selection.length; i++) {
            let hasFlg = false;
            if (courseDataB && courseDataB.length > 0) {
              for (var l = 0; l < courseDataB.length; l++) {
                if (courseDataB[l].courseId === selection[i].courseId) {
                  hasFlg = true;
                }
              }
            }
            if (!hasFlg) {
              _this.courseData.push(selection[i]);
            }
          }
        } else {
          _this.courseData = [];
          if (courseDataB && courseDataB.length > 0) {
            for (var j = 0; j < courseDataB.length; j++) {
              let hasFlg = false;
              for (var k = 0; k < _this.dataList.length; k++) {
                if (courseDataB[j].courseId === _this.dataList[k].courseId) {
                  hasFlg = true;
                }
              }
              if (!hasFlg) {
                _this.courseData.push(courseDataB[j]);
              }
            }
          }
        }
      }
    },
    // 删除已选备件
    handleClose(data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.courseId === this.dataList[a].courseId) {
          this.$refs.selectCourseinfo.toggleRowSelection(
            this.dataList[a],
            false
          ); // 选择当前行
          break;
        }
      }
      this.courseData.splice(this.courseData.indexOf(data), 1);
    },
    // 确认
    onOk: function (flg) {
      let _this = this;
      // _this.$emit('inputss', _this.courseData)
      if (flg === "1") {
        _this.courseData = [];
      }
      _this.courseData.forEach((row) => {
        // this.$message(row.courseCode + '-' + row.courseNameCn)
        this.datalist.push({
          id: row.courseId,
          courseKind: row.courseKind,
          course: row.courseNameCn + "(" + row.courseCode + ")",
        });
      });
      _this.courseData = [];
      console.log("onOk");
      console.log(this.datalist);

      this.$emit("inputss", this.datalist);
      this.datalist = [];
      _this.$refs.selectCourseinfo.clearSelection();
    },
    // 打开页面时，回填勾选
    querSelect() {
      if (this.courseData && this.courseData.length > 0) {
        var map = new Map();
        this.courseData.forEach(function (item, index) {
          // this.$message(item.courseId + '')
          map.set(String(item.courseId), item);
        });
        let _this = this;
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(String(dataitem.courseId))) {
            _this.$refs.selectCourseinfo.toggleRowSelection(dataitem);
          }
        });
      }
    },
    handleCurrentChange(value) {
      this.page = value;
      this.getDataList();
    },
    handleSizeChange(value) {
      this.limit = value;
      this.getDataList();
    },
  },
};
</script>
<style lang="scss" scoped>
.selecttNameClass .element.style {
  width: 100%;
  max-width: 106.6563px;
}
 .firstOne .el-form-item__label {
  text-align: center !important;
}
.M-search {
  overflow: hidden;
  text-align: center;
  min-width: 100px;
  width: 40%;
}
.el-row {
  margin-bottom: 20px;
}
 .el-col-16 {
  padding: 0 !important;
  width: 74%;
}
.selectBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btns {
    display: flex;
    /*width: 160px;*/
    justify-content: flex-end;
  }
}
</style>
